<template>
  <div class=" HotH Ecosystem-huan" style="height:800px;">
    <!-- 初创企业总数 -->
    <p class="data-title">热门行业 TOP20</p>
    <p class="p-huan dian-blue" v-for="(value, index) in total" :key="index">
      {{ value.name }}
      <small>({{ value.value }}%)</small>
    </p>
  </div>
</template>
<script>
export default {
  name: "DataLine",
  props: {
    //  msg: Array
  },
  data() {
    return {
      total: [],
      msg: [
        {
          value: 22.01,
          name: "物联网",
        },
        {
          value: 19.54,
          name: "人工智能",
        },
        {
          value: 16.31,
          name: "SaaS",
        },
        {
          value: 14.21,
          name: "工具软件",
        },
        {
          value: 10.2,
          name: "大数据",
        },
        {
          value: 8,
          name: "机器人",
        },
        {
          value: 7.94,
          name: "材料科技",
        },
        {
          value: 3.89,
          name: "VR/AR",
        },
        {
          value: 3.14,
          name: "芯片技术",
        },
        {
          value: 2.92,
          name: "智能家居",
        },
        {
          value: 2.56,
          name: "半导体/元器件",
        },
        {
          value: 1.86,
          name: "区块链",
        },
        {
          value: 1.86,
          name: "生物技术",
        },
        {
          value: 1.76,
          name: "消费电子",
        },
        {
          value: 1.65,
          name: "可穿戴设备",
        },
        {
          value: 1.4,
          name: "无人机",
        },
        {
          value: 1.19,
          name: "医疗信息化",
        },
        {
          value: 1.14,
          name: "医学检测",
        },
        {
          value: 1.12,
          name: "自然语言处理",
        },
        {
          value: 0.64,
          name: "5G",
        },
        {
          value: 0.6,
          name: "3D打印",
        },
        {
          value: 0.34,
          name: "医疗影像",
        },
        {
          value: 0.33,
          name: "基因技术",
        },
        {
          value: 0.24,
          name: "靶向治疗",
        },
        {
          value: 0.11,
          name: "免疫治疗",
        },
        {
          value: 0,
          name: "互联网",
        },
      ],
    };
  },

  watch: {
    // msg() {
    //   this.total = this.msg.slice(0, 20);
    // }
  },
  created() {
    this.total = this.msg.slice(0, 20);
  },
  methods: {},
};
</script>

<style scoped>
.HotH {
  background: #fff;
  padding: 10px 20px 20px 20px;
  border-radius: 20px;
  margin-top: 20px;
}
.data-title{
  padding-bottom: 1em;
    font-size: 24px;
  color: #333;
  font-weight: 600;
  margin-left: 0;
  padding-top: 16px;
}
 .dian-blue{
   padding: 7px 0;
 }
.p-huan::before {
  content: "";
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 0.5rem;
  background: #6a6fd1;
}
</style>
